import React from 'react';
import { EmployeeSummary } from './types';

interface HistoryFiltersProps {
  selectedEmployee: string | null;
  setSelectedEmployee: (value: string | null) => void;
  eventTypeFilter: string;
  setEventTypeFilter: (value: string) => void;
  dateFromFilter: string;
  setDateFromFilter: (value: string) => void;
  dateToFilter: string;
  setDateToFilter: (value: string) => void;
  employeeSummaries: EmployeeSummary[];
  onFilterToday: () => void;
  onClearFilters: () => void;
}

const HistoryFilters: React.FC<HistoryFiltersProps> = ({
  selectedEmployee, setSelectedEmployee,
  eventTypeFilter, setEventTypeFilter,
  dateFromFilter, setDateFromFilter,
  dateToFilter, setDateToFilter,
  employeeSummaries, onFilterToday, onClearFilters,
}) => (
  <div className="card p-6">
    <h3 className="text-lg font-medium text-gray-900 mb-4">Filters</h3>
    <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">Employee</label>
        <select
          value={selectedEmployee || ''}
          onChange={(e) => setSelectedEmployee(e.target.value || null)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        >
          <option value="">All Employees</option>
          {employeeSummaries.map(emp => (
            <option key={emp.employeeId} value={emp.employeeId}>
              {emp.employeeName} - {emp.rank}
            </option>
          ))}
        </select>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">Event Type</label>
        <select
          value={eventTypeFilter}
          onChange={(e) => setEventTypeFilter(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        >
          <option value="all">All Events</option>
          <option value="sign-on">Sign On</option>
          <option value="sign-off">Sign Off</option>
          <option value="vacation-start">Vacation Start</option>
          <option value="vacation-end">Vacation End</option>
        </select>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">From Date</label>
        <input
          type="date"
          value={dateFromFilter}
          onChange={(e) => setDateFromFilter(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">To Date</label>
        <input
          type="date"
          value={dateToFilter}
          onChange={(e) => setDateToFilter(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        />
      </div>

      <div className="flex items-end">
        <button
          onClick={onFilterToday}
          className="w-full px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          Today
        </button>
      </div>

      <div className="flex items-end">
        <button
          onClick={onClearFilters}
          className="w-full px-4 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500"
        >
          Clear Filters
        </button>
      </div>
    </div>
  </div>
);

export default HistoryFilters;
